module.exports = __webpack_public_path__ + "04_short_gold.c6d3d718.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/04_short_gold.png
// module id = yETk
// module chunks = 0